function popupLocation() {
  const popupLocation = document.getElementById('popup-location')
  const buttons = document.querySelectorAll('.popup-location__button')
  const open = document.querySelector('.header__location');
  const close = document.querySelector('.popup-location__close');

  open.onclick = function() {
    popupLocation.style.display = "flex";
  }

  close.onclick = function() {
    popupLocation.style.display = "none";
  }

  for (let button of buttons) {
    button.onclick = function() {
      popupLocation.style.display = "none";
      localStorage.setItem('popupLocationShown', 'true');
    }
  }
}
popupLocation();